module.exports = __webpack_public_path__ + "media/icons/switch-arrows-72210ff2.svg";